<template>
    <!-- Panel -->
    <!--
        Source Tailwind UI: Two-column in full-width cards
        https://tailwindui.com/components/application-ui/forms/form-layouts#component-b5675d2efaa71ec3767969fd53fc3b66
     -->
    <div class="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
        <slot></slot>
        <div class="md:grid md:grid-cols-3 md:gap-6">
            <!-- Column 1 -->
            <div class="md:col-span-1">
                <slot name="left-column">
                    Report Name
                </slot>
            </div>

            <!-- Column 2 -->
            <div class="mt-5 md:mt-0 md:col-span-2">
                <slot name="right-column">
                    Report Details
                </slot>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "BaseReport",
    mixins: [],
    components: {},
    props: {

    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {

    },
    watch: {

    },
    computed: {

    },
}

</script>

<style scoped>

</style>